import React from 'react';
import { useTranslation } from 'react-i18next';
import { PostDTO } from 'dto/post';
import { DepartmentPost } from '../BoardPost';

interface Props {
  posts?: PostDTO[];
}

const DepartmentComments = ({ posts = [] }: Props) => {
  const { t } = useTranslation('board');
  return (
    <div className="board_content_wrapper_left board-content-wrapper-left">
      <div className="board_header small">
        <img src="images/icon_bookmarks_chat_24.svg" alt="" className="board_icon_chatbox small" />
        <div>{t('label.departmentPosts')}</div>
      </div>
      <div className="board_inner_wrapper">
        {posts.map(post => {
          return <DepartmentPost key={post.postId} post={post} />;
        })}
      </div>
    </div>
  );
};

export default DepartmentComments;
